"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeginCheckoutEvent = void 0;
const abstract_sales_event_1 = require("./abstract-sales.event");
class BeginCheckoutEvent extends abstract_sales_event_1.AbstractSalesEvent {
    constructor(config) {
        super(config);
        this.config = config;
        this.name = 'begin_checkout';
    }
    getData() {
        return {
            currency: this.config.currency,
            value: this.config.value,
            coupon: this.config.coupon,
            items: Array.isArray(this.config.items) ? this.config.items.map(item => (Object.assign({}, item))) : [],
        };
    }
}
exports.BeginCheckoutEvent = BeginCheckoutEvent;
//# sourceMappingURL=begin-checkout.event.js.map